import { render, staticRenderFns } from "./CurrentCaldates.vue?vue&type=template&id=2378e08c&scoped=true&"
import script from "./CurrentCaldates.vue?vue&type=script&lang=ts&"
export * from "./CurrentCaldates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378e08c",
  null
  
)

export default component.exports